module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!-- 点击 "预定" 按钮时弹出的面板 -->\n<section>\n\n\n    <!-- 价格日历 -->\n    <section class="calendar-price-wrap">\n        <div class="month-switch-bar-wrap">\n            <div class="month-switch-bar month-left hidden"></div>\n            <div class="month-switch-bar month-right"></div>\n            <input type="hidden" class="hiddenOrderPrice">\n        </div>\n\n        <!-- 各月份的字符串 -->\n        ' +
((__t = ( monthStr )) == null ? '' : __t) +
'\n    </section>\n\n\n</section>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/common/hotelCalendarPrice/templates/orderParamPanel.ejs
// module id = 215
// module chunks = 6